export enum NotificationTargetTypeEnum {
  DANCE_CLASS = 'DANCE_CLASS',
  DANCE_EVENT = 'DANCE_EVENT',
  ROOM_RENTAL = 'ROOM_RENTAL',
  LOCATION = 'LOCATION',
  USER = 'USER',
  DANCE_MANAGER = 'DANCE_MANAGER',
}
